export default __webpack_public_path__ + "static/media/icon-Hub-Publish.0cf2f479.svg";